import { Select } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRootStore } from 'store/rootStore';
import { EnrollmentStage } from 'types/enrollmentService';
import { toJS } from 'mobx';
import { imCelticsRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import MoreDropdown from './MoreDropdown';
import { createStyles } from './styles';

const FiltersPanel: React.FC = observer(() => {
  const classes = createStyles();
  const {
    userStore: { userRoles },
    triggerRenewalsStore: {
      paginationDelegate: { filters, setFilterValue },
      getSponsorOptions,
      getEffectiveDateOptions,
      getStageOptions,
    },
  } = useRootStore();

  const convertedRoles = userRoles.map((role) => toJS(role)).slice();
  const isImCeltics = imCelticsRights(convertedRoles);

  const onSetSponsorId = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    setFilterValue('sponsorId', e.target.value);
  };

  const onSetEffectiveDate = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    setFilterValue('effectiveDate', e.target.value);
  };

  const onSetStage = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    setFilterValue('stage', e.target.value as EnrollmentStage);
  };

  return (
    <div className={classes.infoHeader}>
      <div className={classes.headerBlock}>
        {isImCeltics && (
          <Select
            label="Sponsor Id"
            name="sponsorId"
            options={getSponsorOptions()}
            onChange={onSetSponsorId}
            value={filters.sponsorId}
            width="23rem"
            validationPassed={!!filters.sponsorId}
            validationMessage="Please select sponsor"
          />
        )}
        <Select
          label="Effective Date"
          name="effectiveDate"
          options={getEffectiveDateOptions()}
          onChange={onSetEffectiveDate}
          value={filters.effectiveDate}
          width="23rem"
          validationPassed={!!filters.effectiveDate}
          validationMessage="Please select effective date"
        />
        <Select
          label="Stage"
          name="stage"
          options={getStageOptions()}
          onChange={onSetStage}
          value={filters.stage}
          width="23rem"
        />
      </div>
      <MoreDropdown />
    </div>
  );
});

export default FiltersPanel;
